import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { StockTake } from '../models/stockTake';

export class StockTakeService extends BaseService<StockTake> {
  override model = StockTake;
  override modelName = 'stockTake';
  override modelLabel = 'Stock Take';

  async apply(
    stockTake: StockTake,
  ): Promise<ApiResponse<StockTake>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${stockTake.objectID()}/apply`,
    });

    return await this.requestItem(request, StockTake);
  }
}
